module.exports = __webpack_public_path__ + "static/media/ios-app-popup.d6cf56a2.jpg";